import React from 'react';
import { Instagram } from 'lucide-react';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b-2 border-logo-teal shadow-sm">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_nostalgic-shots-14/artifacts/vuwy1zic_unnamed.jpg"
              alt="Vintage Camera Box Logo"
              className="h-16 w-auto"
            />
          </div>
          
          <nav className="hidden md:flex items-center gap-6">
            <a href="#features" className="text-logo-navy hover:text-logo-teal transition-colors font-medium">Features</a>
            <a href="#pricing" className="text-logo-navy hover:text-logo-teal transition-colors font-medium">Pricing</a>
            <a href="#contact" className="text-logo-navy hover:text-logo-teal transition-colors font-medium">Contact</a>
            <a href="https://instagram.com/vintagecamerabox" target="_blank" rel="noopener noreferrer" className="text-logo-navy hover:text-logo-teal transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;